module.exports = __webpack_public_path__ + "files/7348a9121446f2c086b5d2aafb4b7448.png";